import { useState as o, useCallback as u, useEffect as s, useRef as v, useLayoutEffect as I } from "react";
import { BREAKPOINTS as S } from "./libServer.js";
import { EVENTS_HE as P, LOCALIZED_DOMAINS as F, MODULES_HE as K, addDaysToDate as N, calculateDaysDifference as U, convertDateToISODateString as Z, debounce as j, dispatchEvent as q, formatDateToLocale as G, getHeaders as J, getServerHeaders as Q, isBrowser as X, parseCookies as Y } from "./libServer.js";
function O(e) {
  const [t, n] = o(!!e), r = u(() => n(!0), []), i = u(() => n(!1), []), f = u(() => n((w) => !w), []);
  return { value: t, setValue: n, setTrue: r, setFalse: i, toggle: f };
}
function k(e, t = 500) {
  const [n, r] = o(e);
  return s(() => {
    const i = setTimeout(() => r(e), t);
    return () => {
      clearTimeout(i);
    };
  }, [e, t]), n;
}
function y() {
  const [e, t] = o({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return s(() => {
    function n() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n);
  }, []), e;
}
const A = typeof window < "u" ? I : s;
function B(e, t) {
  const n = v(e);
  A(() => {
    n.current = e;
  }, [e]), s(() => {
    if (!t && t !== 0)
      return;
    const r = setTimeout(() => {
      n.current();
    }, t);
    return () => {
      clearTimeout(r);
    };
  }, [t]);
}
function R() {
  const { width: e } = y();
  let t = "desktop";
  return e && e <= S.MOBILE ? t = "mobile" : e && e <= S.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop"
  };
}
function W(e, t, n) {
  s(() => {
    if (window)
      return window.addEventListener(e, t, n), () => {
        window.removeEventListener(e, t, n);
      };
  }, [e, t, n]);
}
function C() {
  const e = v(!1), t = u(() => e.current, []);
  return s(() => (e.current = !0, () => {
    e.current = !1;
  }), []), t;
}
function M(e) {
  return Array.isArray(e);
}
function V({
  promiseFn: e,
  enabled: t = !0,
  initialData: n
}) {
  const r = v(0), i = C(), [f, w] = o(n ?? void 0), [l, h] = o(t ?? !1), [p, D] = o(void 0), [g, E] = o(t ?? !1), [m, T] = o(!1), a = u(
    async (...d) => {
      const L = ++r.current;
      l || h(!0);
      try {
        if (!M(d))
          throw new Error("Invalid arguments provided to the promise function.");
        const c = await e(...d);
        i() && L === r.current && (w(c), h(!1), E(!1));
      } catch (c) {
        if (i() && L === r.current)
          throw c instanceof Error ? D(c) : D(new Error("An unknown error occurred")), h(!1), E(!1), c;
      }
    },
    [i, l, e]
  );
  s(() => {
    g && !m && a();
  }, [g, a, m]);
  const b = u(
    async (...d) => {
      T(!0), E(!0), await a(...d), T(!1);
    },
    [a]
  );
  return { data: f, loading: l, error: p, refetching: m, refetch: b };
}
export {
  S as BREAKPOINTS,
  P as EVENTS_HE,
  F as LOCALIZED_DOMAINS,
  K as MODULES_HE,
  N as addDaysToDate,
  U as calculateDaysDifference,
  Z as convertDateToISODateString,
  j as debounce,
  q as dispatchEvent,
  G as formatDateToLocale,
  J as getHeaders,
  Q as getServerHeaders,
  X as isBrowser,
  Y as parseCookies,
  O as useBoolean,
  k as useDebounce,
  R as useDevice,
  W as useEvent,
  C as useMountedState,
  V as usePromise,
  B as useTimeout,
  y as useWindowSize
};
